export default __webpack_public_path__ + "static/media/img4.f105fa56.png";